import { useEffect, useState } from "react";
import { CmsService } from "@/services/cmsService";

let cache = null;
let inflight = null;

function normalizeSettings(raw) {
  if (!raw || typeof raw !== "object") return {};
  const inner = raw.data;
  if (inner && typeof inner === "object" && !Array.isArray(inner)) {
    const keys = ["bookmarkers", "top_banner", "banner", "gmnc_banner_image", "keo_bong_vip_logo_link", "domain_site"];
    const rawHit = keys.some((key) => key in raw);
    const innerHit = keys.some((key) => key in inner);
    if (innerHit && !rawHit) return inner;
  }
  return raw;
}

export function useSettings() {
  const [settings, setSettings] = useState(cache || {});
  const [ready, setReady] = useState(Boolean(cache));

  useEffect(() => {
    let cancelled = false;
    if (!inflight) {
      inflight = CmsService.getSettingsAll().then((data) => normalizeSettings(data));
    }
    inflight.then((data) => {
      cache = data || {};
      if (!cancelled) {
        setSettings(cache);
        setReady(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { settings, ready };
}
